import { Injector, Component, OnInit, ViewChildren, HostListener, OnDestroy, ViewChild, EventEmitter, Output } from '@angular/core';
import { forkJoin, map } from 'rxjs';
import * as _moment from 'moment';
import { Moment } from 'moment';
import { ActivatedRoute } from '@angular/router';
import { DxFormComponent } from 'devextreme-angular';
import { Subscription } from 'rxjs';
import DataGrid from 'devextreme/ui/data_grid';
import ArrayStore from 'devextreme/data/array_store';

// components
import { FullListComponent } from '../../shared/components/full-list/full-list.component';
import { PrebidOnProductItemComponent } from './prebid-on-product-item.component';
import { TranslatableFieldComponent } from '../../shared/components/translatable-field/translatable-field.component';

// models
import { ApplicationSettings } from '../../shared/models/application-settings';
import { GridProperty, ProductProperty } from '../../shared/models/product';
import { Language } from '../../shared/models/language';
import { LookupTable, LookupTableField } from '../../shared/models/lookup-table';
import { MasterData } from '../../shared/models/master-data';
import { ProductPropertyTypeEnum } from '../../shared/enum/productPropertyTypeEnum';
import { Supplier } from '../../shared/models/supplier';
import { PrebidOnProduct, PrebidOnProductProperty } from '../../shared/models/prebid-on-product';
import { BuyerLevelSubbuyer } from '../shared/models/buyer-level-subbuyer';

// services
import { TranslateService } from '@ngx-translate/core';
import { ServiceFactory } from '../../shared/factory/service-factory';
import { DateTimeService } from '../../shared/services/datetime.service';
import { LanguageService } from '../../shared/services/language.service';
import { WebApiService } from '../../shared/services/web-api.service';

import { LookupTableService } from '../shared/services/lookup-table.service';
import { MasterDataService } from '../shared/services/master-data.service';
import { PrebidOnProductService } from '../shared/services/prebid-on-product.service';
import { ProductService } from '../shared/services/product.service';
import { SupplierService } from '../shared/services/supplier.service';

const moment = (_moment as any).default ? (_moment as any).default : _moment;

export class MasterDataDropdown {
  value: any;
  label: string;
}

@Component({
  selector: 'prebid-on-product-component',
  templateUrl: 'prebid-on-product.component.html',
  styleUrls: ['./prebid-on-product.component.scss']
})
export class PrebidOnProductComponent extends FullListComponent<PrebidOnProduct, PrebidOnProductItemComponent> implements OnInit, OnDestroy {
  @ViewChildren(TranslatableFieldComponent) translatableFields: Array<TranslatableFieldComponent> = [];
  @Output() numberOfPrebidsChanged = new EventEmitter<number>();

  lookupTableService: LookupTableService;
  masterDataService: MasterDataService;
  productService: ProductService;

  languages: Array<Language> = [];
  auctionClusterId: number;
  secondRestrictionMasterDataId: number;
  buyerSecondRestrictionMasterDataRowIds: Array<number>;
  productId: number;
  // prebidOnProduct: PrebidOnProduct = new PrebidOnProduct();
  prebidPropertyFields = [];
  masterDatas: Array<MasterData> = [];
  masterDataDropdowns: Array<any> = [];
  masterDataDropdownsFiltered: Array<any> = [];
  comboBoxes: Array<any> = [];
  suppliers: Array<Supplier> = [];
  firstLoad = true;
  visible = false;
  isEditMode = false;
  errorMessage = null;
  JSON: any = JSON;
  model: PrebidOnProduct = new PrebidOnProduct();
  lookupTables: Array<LookupTable> = [];
  lang = 'nl-be';
  dataGridInstance: DataGrid;
  secondRestrictionLotPropertyFilled = false;
  requiredPrebidOnProductPropertiesFilled = false;
  productProperties: Array<ProductProperty> = [];
  prebidOnProductProperties: Array<GridProperty> = [];
  subbuyerDataSource : ArrayStore;
  subbuyers: Array<BuyerLevelSubbuyer>;
  selectedSubbuyer: BuyerLevelSubbuyer;
  currentTabIndex: number;

  rtlEnabled = localStorage.getItem('last-selected-language-direction') ? JSON.parse(localStorage.getItem('last-selected-language-direction')) : false;
  private _subscription: Subscription;
  gridColumns = [];
  gridData = [];
  prebidOnProductFormItems = [];
  dataGridColumns=[{
          dataField: null,
          visibleIndex: null,
          allowEditing: false,
          encodeHtml: false,
          editorOptions: null,
          width:120,
          cellTemplate:'checkBoxTemplate',
          caption: this.translate.instant("SUPPLY_MONITOR.ALL_OR_NOTHING"),
          type:null
        },
      {
          dataField: null,
          visibleIndex: null,
          allowEditing: false,
          encodeHtml: false,
          editorOptions: null,
          width:120,
          cellTemplate:'buttonsTemplate',
          caption: null,
          type: "buttons"
      }];
  //type="buttons" [width]="120" cellTemplate='buttonsTemplate'
  dataGridItems=[];

  constructor(
    protected injector: Injector,
    protected appSettings: ApplicationSettings,
    protected route: ActivatedRoute,  
    protected webApiService: WebApiService,
    private languageService: LanguageService,
    private dataService: PrebidOnProductService,
    private supplierService: SupplierService,
    private translateService: TranslateService,
    private dateTimeService: DateTimeService
  ) {
    super(injector, PrebidOnProduct);
    this.getServices(route, appSettings, webApiService);

    this.lang = this.translateService.currentLang;
    this._subscription = this.languageService.direction.subscribe(dir => {
      this.rtlEnabled = dir;
    });
  }

  ngOnInit() {
    this.setTranslations('PREBID_ON_PRODUCT');
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this._subscription.unsubscribe();
  }

  getServices(route, appSettings, webApiService) {
    this.lookupTableService = ServiceFactory.getLookupTableService(route, appSettings, webApiService) as LookupTableService;
    this.masterDataService = ServiceFactory.getMasterDataService(document.location.hash, route, appSettings, webApiService) as MasterDataService;
    this.productService = ServiceFactory.getProductService(document.location.hash, route, appSettings, webApiService) as ProductService;
  }

  open(auctionClusterId: number, productId: number, secondRestrictionMasterDataId: number, buyerSecondRestrictionMasterDataRowIds: Array<number>, subbuyers:Array<BuyerLevelSubbuyer>) {
    this.auctionClusterId = auctionClusterId;
    this.secondRestrictionMasterDataId = secondRestrictionMasterDataId;
    this.buyerSecondRestrictionMasterDataRowIds = buyerSecondRestrictionMasterDataRowIds;
    if (productId !== this.productId) {
      this.firstLoad = true;
    }
    this.productId = productId;

    this.visible = true;
    this.subbuyers=subbuyers;
    this.subbuyers.forEach(s => s.displayValue=s.subNumber+' - '+s.name);
    this.subbuyerDataSource=new ArrayStore(
      { 
        data: this.subbuyers,
        key: "name",
      }
    )

    this.getData();
  }

  getData() {
    if (!this.auctionClusterId || !this.productId) {
      return;
    }
    this.spinner.show();
    forkJoin(
      this.dataService.getPrebidsOnProduct(this.id, this.auctionClusterId, this.productId),
      this.languageService.getLanguages(),
      this.productService.getProductProperties(this.productId),
      this.productService.getPrebidOnProductProperties(this.auctionClusterId, this.productId)
    ).subscribe(async (result: Array<any>) => {
      this.items = result[0];
      this.numberOfPrebidsChanged.emit(this.items.length);
      this.languages = result[1];
      // tslint:disable-next-line:no-magic-numbers
      this.productProperties = result[2];
      this.prebidOnProductProperties = result[3];
      if (this.firstLoad) {
        this.lookupTableService.getLookupTablesForReports(null, this.productId).subscribe(lt => {
          this.lookupTables = lt;
        });
        this.getMasterDataListsAndSuppliers();
        this.firstLoad = false;
      } else {
        await this.parseData();
      }
      this.generateForm();
    },
      error => {
        this.errorService.show(error);
        this.spinner.hide();
      });
  }

  initModelOnNew() {
    this.model = new PrebidOnProduct();
    this.loadSelectedSubbuyer();
    this.parseModel();
    this.isEditMode = false;
  }

  delete(prebidOnProductId) {
    this.itemIdToDelete = prebidOnProductId;
    this.deleteSelected();
  }

  edit(prebidOnProductId) {
    this.isEditMode = true;
    this.currentTabIndex=1;
    this.spinner.show();
    this.dataService.getPrebidOnProduct(this.id, this.auctionClusterId, prebidOnProductId)
      .subscribe((res: PrebidOnProduct) => {
        this.model = res;
        this.loadSelectedSubbuyer();
        this.parseModel();
        this.generateForm();

        this.model.prebidOnProductProperties.filter(l => l.masterDataListId != undefined).forEach(lp => {
          var newValues = [];
          const lookupTableId = this.isProductWithLookupTable(lp.productPropertyId);
          if (lookupTableId > -1) {
            this.lookupTableService.getLookupTableForProductPropertyForPrebidOnProduct(null, lp.productPropertyId, this.model)
              .subscribe(lookup => {
                if (lookup.lookupTableType === 0 && lookup.lookupTableRows.length > 0) {
                  lookup.lookupTableRows.forEach(row => {
                    if (row.resultMasterDataListRowId) {
                      newValues.push(row.resultMasterDataListRowId);
                    }
                    else {
                      row.lookupTableValues.forEach(value => {
                        newValues.push(value.masterDataListRowId);
                      });
                    }
                  });
                }
              });
            console.log(lp);
            this.masterDataDropdownsFiltered[lp.masterDataListId.toString()] = newValues;
          }
        });

        this.model.prebidOnProductProperties = this.model.prebidOnProductProperties.filter(e => e.propertyTypeId !== undefined);
        this.sortArray(this.model.prebidOnProductProperties, 'orderNumber', 1);
        this.spinner.hide();
      },
        error => {
          this.errorService.show(error);
          this.spinner.hide();
        });
  }

  createEmtpyObjectForTranslatableFields() {
    // Create empty JSON object for translation fields
    const emptyTranslation = {};
    this.languages.forEach(lang => {
      emptyTranslation[lang.code] = '';
    });

    return JSON.stringify(emptyTranslation);
  }


  dateChanged(property: any, dateTime: Moment) {
    const matches = property.dataField.match(/\[(.*?)\]/);
    this.model.prebidOnProductProperties[Number(matches[1])].dateTimeValue = moment(dateTime).toDate();
  }

  dateValue(property: any) {
    const matches = property.dataField.match(/\[(.*?)\]/);
    return this.model.prebidOnProductProperties[Number(matches[1])].dateTimeValue;
  }

  clearLotPropertyValue(prebidOnProductProperty: PrebidOnProductProperty) {
    const lp = this.model.prebidOnProductProperties.find(lp => lp.prebidOnProductPropertyId === prebidOnProductProperty.prebidOnProductPropertyId);
    if (lp) {
      lp.masterDataListRowId = null;
    }
  }

  parseBeforeSave() {
    this.model.prebidOnProductProperties.forEach(prebidOnProductProperty => {
      if (prebidOnProductProperty.propertyTypeId === ProductPropertyTypeEnum.DATE && prebidOnProductProperty.dateTimeValue) {
        prebidOnProductProperty.dateTimeValue = moment.utc(prebidOnProductProperty.dateTimeValue);
      }

      if (prebidOnProductProperty.propertyTypeId === ProductPropertyTypeEnum.TEXT && prebidOnProductProperty.translatable) {
        const field = this.translatableFields.find(tf => tf.componentIndex === prebidOnProductProperty.productPropertyId);
        if (field) {
          prebidOnProductProperty.stringValue = field.data;
        }
      }
    });
    this.model.subbuyerId=this.selectedSubbuyer?.buyerId;
    this.model.subnumber=this.selectedSubbuyer?.subNumber;
    if(this.model.allOrNothing)
      this.model.minAmount=this.model.amountWanted;
  }

  onMasterDataValueChanged(e: any, data: any, property: PrebidOnProductProperty) {
    data.component.updateData(data.dataField, e.value);
    this.onPropertyChanged(property);
  }

  save() {
    this.parseBeforeSave();

    if (this.model.prebidOnProductId) {
      this.isEditMode = true;
    }

    if (this.isEditMode) {
      this.spinner.show();
      this.dataService.editPrebidOnProduct(this.id, this.auctionClusterId, this.model)
        .subscribe((res: any) => {
          this.model = new PrebidOnProduct();
          this.loadSelectedSubbuyer();
          this.initModelOnNew();
          this.errorMessage = null;
          this.spinner.hide();
          this.getData();
          this.currentTabIndex=0;
        },
          err => {
            if (err.error && err.error.length > 0 && err.error[0].ErrorMessage === 'RESTRCTED_LOT_PROPERTY_VALUE') {
              this.errorMessage = this.translations.RESTRCTED_LOT_PROPERTY_VALUE;
              let prebidOnProductPropertyName = this.model.prebidOnProductProperties.find(_ => _.productPropertyId ===  err.error[0].ProductPropertyId).name;
              this.errorMessage += ' Prebid on product property name: ' + prebidOnProductPropertyName;
              this.errorService.show(this.errorMessage);
            } else {
              this.errorService.show(err);
            }
            this.spinner.hide();
          });
    } else {
      this.spinner.show();
      this.dataService.savePrebidOnProductForProduct(this.id, this.auctionClusterId, this.productId, this.model)
        .subscribe((res: any) => {
          this.model = new PrebidOnProduct();
          this.loadSelectedSubbuyer();
          this.initModelOnNew();
          this.errorMessage = null;
          this.spinner.hide();
          this.getData();
          this.currentTabIndex=0;
        },
          err => {
            if (err.error && err.error.length > 0 && err.error[0].ErrorMessage === 'RESTRCTED_LOT_PROPERTY_VALUE') {
              this.errorMessage = this.translations.RESTRCTED_LOT_PROPERTY_VALUE;
              let prebidOnProductPropertyName = this.model.prebidOnProductProperties.find(_ => _.productPropertyId ===  err.error[0].ProductPropertyId).name;
              this.errorMessage += ' Prebid on product property name: ' + prebidOnProductPropertyName;
              this.errorService.show(this.errorMessage);
            } else {
              this.errorService.show(err);
            }
            this.spinner.hide();
          });
    }
  }

  parseModel() {
    if (this.model.prebidOnProductProperties.length === 0) {
      this.prebidPropertyFields.forEach(ppf => {
        // check if falready added
        const alreadyAddedProp = this.model.prebidOnProductProperties.find(p => p.productPropertyId === ppf.productPropertyId);
        if (!alreadyAddedProp) {
          const newObj = new PrebidOnProductProperty();
          newObj.orderNumber = ppf.orderNumber;
          newObj.masterDataListFieldId = ppf.masterDataListFieldId;
          newObj.name = ppf.name;
          newObj.propertyTypeId = ppf.propertyTypeId;
          newObj.propertyTypeFormatId = ppf.propertyTypeFormatId;
          newObj.productPropertyId = ppf.productPropertyId;
          newObj.translatable = ppf.translatable;
          newObj.masterDataListId = ppf.masterDataListId;
          newObj.required = ppf.required;
          if (newObj.translatable) {
            newObj.stringValue = this.createEmtpyObjectForTranslatableFields();
          }
          this.model.prebidOnProductProperties.push(newObj);
        }
      });
    } else {
      this.model.prebidOnProductProperties.forEach(lp => {
        const field = this.prebidPropertyFields.find(ppf => ppf.productPropertyId === lp.productPropertyId);
        if (field) {
          lp.orderNumber = field.orderNumber;
          lp.masterDataListFieldId = field.masterDataListFieldId;
          lp.name = field.name;
          lp.propertyTypeId = field.propertyTypeId;
          lp.propertyTypeFormatId = field.propertyTypeFormatId;
          lp.translatable = field.translatable;
          lp.masterDataListId = field.masterDataListId;
          lp.required = field.required;

          if (lp.propertyTypeId === ProductPropertyTypeEnum.DATE && lp.dateTimeValue) {
            const serverReturnedTime = moment.utc(lp.dateTimeValue);
            lp.dateTimeValue = moment(serverReturnedTime).local();
          }
        }
      });
    }

    this.sortArray(this.model.prebidOnProductProperties, 'orderNumber', 1);
  }

  getPropIdsForMasterDataFields(lookupTableFields: Array<LookupTableField>) {
    const ids = [];
    lookupTableFields.forEach(ltf => {
      if (ltf.isResult) {
        this.productProperties.forEach(pp => {
          if (pp.masterDataListId === ltf.masterDataListId) {
            ids.push(pp.productPropertyId);
          }
        });
      }
    });

    return ids;
  }

  getLookupDependentPropIds(productPropertyId: number) {
    let dependentPropIds = [];
    const productProperty = this.productProperties.find(f => f.productPropertyId === productPropertyId);
    if (!productProperty) {
      return dependentPropIds;
    }
    const productPropertyMasterData = productProperty.masterDataListId;
    if (!productPropertyMasterData) {
      return dependentPropIds;
    }
    for (let i = 0; i < this.lookupTables.length; i += 1) {
      if (this.lookupTables[i].lookupTableType === 1) {
        continue;
      }
      for (let j = 0; j < this.lookupTables[i].lookupTableFields.length; j += 1) {
        if (!this.lookupTables[i].lookupTableFields[j].isResult
          && this.lookupTables[i].lookupTableFields[j].masterDataListId === productPropertyMasterData) {
          const propIds = this.getPropIdsForMasterDataFields(this.lookupTables[i].lookupTableFields);
          dependentPropIds = [...dependentPropIds, ...propIds];
        }
      }
    }

    return dependentPropIds;
  }

  isProductWithLookupTable(productPropertyId: number) {
    for (let i = 0; i < this.productProperties.length; i += 1) {
      if (this.productProperties[i].productPropertyId === productPropertyId
        && this.productProperties[i].lookupTableId) {
        return this.productProperties[i].lookupTableId;
      }
    }

    return -1;
  }

  onPropertyChanged(property: PrebidOnProductProperty) {
    for (let i = 0; i < this.masterDataDropdowns.length; i += 1) {
      this.masterDataDropdownsFiltered[this.masterDataDropdowns[i].masterDataListId.toString()] = null;
      this.lookupTableService.getLookupTableForProductPropertyForPrebidOnProduct(null, this.masterDataDropdowns[i].productPropertyId, this.model)
        .subscribe(lookup => {
          if (lookup) {
            var newValues = [];
            if (lookup.lookupTableType === 0 && lookup.lookupTableRows.length > 0) {
              if (lookup && lookup.lookupTableType == 0) {
                lookup.lookupTableRows.forEach(row => {
                  if (row.resultMasterDataListRowId) {
                    newValues.push(row.resultMasterDataListRowId);
                  }
                  else {
                    row.lookupTableValues.forEach(value => {
                      newValues.push(value.masterDataListRowId);
                    });
                  }
                });
              }
            }
          }
          this.masterDataDropdownsFiltered[this.masterDataDropdowns[i].masterDataListId.toString()] = newValues;
        });
    }
  }

  getSuppliers() {
    this.supplierService.getSuppliers(this.auctionClusterId).subscribe(s => {
      this.suppliers = s;
    });
  }

  getLotPropertyDisplayValue(prebidOnProductProperties: Array<PrebidOnProductProperty>, propField: any) {
    const lp = prebidOnProductProperties.find(p => p.productPropertyId === propField.productPropertyId);

    if (lp) {
      return lp.displayValue;
    }

    return '-';
  }

  getMasterDataListsAndSuppliers() {
    const masterDataListIds: Array<number> = [];
    this.productProperties.forEach(property => {
      if (property.masterDataListId) {
        if (masterDataListIds.indexOf(property.masterDataListId) === -1) {
          masterDataListIds.push(property.masterDataListId);
        }
      }
    });

    this.supplierService.getSuppliers(this.auctionClusterId).subscribe(s => {
      this.suppliers = s;

      const observables = [];

      masterDataListIds.forEach(id => {
        observables.push(this.masterDataService.getMasterDataForReports(this.auctionClusterId, id, false)
          .pipe(map((result: MasterData) => result)));
      });

      forkJoin(
        observables
      ).subscribe(async res => {
        for await (var result of res) {
          this.masterDatas.push(result);
          const catalogMasterDataIds: Array<number> = [];
          this.masterDatas.forEach(masterData => {
            masterData.fields.forEach(masterDataListField => {
              if (masterDataListField.useFieldInCatalog) {
                catalogMasterDataIds.push(masterDataListField.masterDataListFieldId);
              }
            });
          });
        };
        await this.parseData();
      });
    });
  }

  getMasterDataFieldName(selection: GridProperty) {
    for (let i = 0; i < this.masterDatas.length; i += 1) {
      for (let j = 0; j < this.masterDatas[i].fields.length; j += 1) {
        if (this.masterDatas[i].fields[j].masterDataListFieldId === selection.masterDataListFieldId) {
          return this.getTranslation(this.masterDatas[i].fields[j].name);
        }
      }
    }
  }

  async parseData() {
    const prebidPropertyFields = [];
    this.sortArray(this.prebidOnProductProperties, 'orderNumber', 1);
    const prebidSelection = this.prebidOnProductProperties;
    prebidSelection.forEach(selection => {
      let fieldObj = null;

      const productProperty = this.productProperties.find(p => p.productPropertyId === selection.productPropertyId);
      if (productProperty) {
        let name = this.getTranslation(productProperty.name);
        if (productProperty.propertyTypeId === ProductPropertyTypeEnum.MASTER_DATA) {
          const fieldName = this.getMasterDataFieldName(selection);
          name = `${name} (${fieldName})`;
        }
        fieldObj = {
          ...selection,
          name,
          propertyTypeId: productProperty.propertyTypeId,
          propertyTypeFormatId: productProperty.propertyTypeFormatId,
          translatable: productProperty.translatable,
          masterDataListId: productProperty.masterDataListId
        };
      }

      if (fieldObj) {
        prebidPropertyFields.push(fieldObj);
      }
    });

    this.prebidPropertyFields = prebidPropertyFields;

    for await (var i of this.items) {
      var subbuyerProperty = new PrebidOnProductProperty();
      var priceProperty = new PrebidOnProductProperty();
      var amountProperty = new PrebidOnProductProperty();
      var minAmountProperty = new PrebidOnProductProperty();
      var maxAmountProperty = new PrebidOnProductProperty();
      var spentAmountProperty = new PrebidOnProductProperty();
      
      subbuyerProperty.displayValue='-';
      if(i.subbuyerId!=null)
      {
        var subbuyer = this.subbuyers.find(s => s.buyerId==i.subbuyerId && s.subNumber==i.subnumber);
        subbuyerProperty.displayValue=subbuyer.displayValue;
      }
      
      priceProperty.displayValue=i.price.toString();
      amountProperty.displayValue=i.amountWanted.toString();
      if (!i.displayPrebidOnProductProperties) {
            i.displayPrebidOnProductProperties = [];
          }
      minAmountProperty.displayValue=i.allOrNothing?"-":i.minAmount.toString();
      maxAmountProperty.displayValue=i.maxAmount.toString();
      spentAmountProperty.displayValue=i.spentAmountPrebid.toString();
      

      for await (var pp of this.prebidPropertyFields) {
        const prebidOnProductProperty = i.prebidOnProductProperties.find(lp => lp.productPropertyId === pp.productPropertyId);
        if (prebidOnProductProperty) {
          const displayPrebidOnProductProp = JSON.parse(JSON.stringify(prebidOnProductProperty));
          displayPrebidOnProductProp.displayValue = await this.findPropertyValue(prebidOnProductProperty, pp);
          
          i.displayPrebidOnProductProperties.push(displayPrebidOnProductProp);
        }
      };
      
      i.displayPrebidOnProductProperties.push(amountProperty);
      i.displayPrebidOnProductProperties.push(minAmountProperty);
      i.displayPrebidOnProductProperties.push(maxAmountProperty);
      i.displayPrebidOnProductProperties.push(priceProperty);
      i.displayPrebidOnProductProperties.push(spentAmountProperty);
      i.displayPrebidOnProductProperties.push(subbuyerProperty);
    };

    this.parseModel();
    this.generateTable();
  }

  async getMasterDataValue(prebidOnProductProperty: PrebidOnProductProperty, masterdataListId: number): Promise<string> {
    var masterDataListRowId = prebidOnProductProperty.masterDataListRowId;
    if (masterDataListRowId == undefined || masterdataListId == undefined) {
      return '';
    }
    var result = await this.masterDataService.getMasterDataValueForDropdown(masterdataListId, this.auctionClusterId, this.translateService.currentLang, masterDataListRowId).toPromise();
    if (result.data && result.data.length > 0) {
      return result.data[0].label;
    }
    return '';
  }


  async findPropertyValue(prebidOnProductProperty: PrebidOnProductProperty, prop: any): Promise<any> {
    if (prebidOnProductProperty.dateTimeValue) {
      return this.dateTimeService.getDateStringByFormatAnyUtc(prebidOnProductProperty.dateTimeValue, prop.propertyTypeFormatId);
    } else if (prebidOnProductProperty.decimalValue) {
      return prebidOnProductProperty.decimalValue;
    } else if (prebidOnProductProperty.intValue) {
      return prebidOnProductProperty.intValue;
    } else if (prebidOnProductProperty.stringValue) {
      if (prop.translatable) {
        return this.getTranslation(prebidOnProductProperty.stringValue);
      }
      return prebidOnProductProperty.stringValue;
    } else if (prop.propertyTypeId === ProductPropertyTypeEnum.BOOLEAN) {
      return prebidOnProductProperty.booleanValue ? 'true' : 'false';
    } else if (prebidOnProductProperty.masterDataListRowId) {
      // return lotProperty.masterDataListRowId;
      return await this.getMasterDataValue(prebidOnProductProperty, prop.masterDataListId);
    }

    return '';
  }


  getTranslation(value: string) {
    return this.languageService.getTranslatableText(value);
  }

  deleteSelected() {
    this.spinner.show();
    this.dataService.deletePrebidOnProduct(this.id, this.auctionClusterId, this.itemIdToDelete)
      .subscribe((prebids: Array<PrebidOnProduct>) => {
        this.getData();
        this.spinner.hide();
      },
        error => {
          this.errorService.show(this.errorService.translations.DELETE_ERROR_MESSAGE);
          this.spinner.hide();
        });
  }

  close() {
    this.visible = false;
  }

  initColumn = (e: any) => {
    this.dataGridInstance = e.component;
  }

  generateTable = () => {
    const items = [];
    const columnsArray = [];

    this.prebidPropertyFields.forEach((row: any, i: number) => {
      let columnName = this.getTranslation(row.name);
      if (columnsArray.includes(columnName)) {
        let j = 0;
        do {
          columnName = this.getTranslation(row.name) + j;
          j++;
        } while (columnsArray.includes(columnName));
      }
      columnsArray.push(columnName);
    });

    columnsArray.push(this.translate.instant("SHARED.AMOUNT"));
    columnsArray.push(this.translate.instant("PREBID_ON_PRODUCT.MIN_AMOUNT"));
    columnsArray.push(this.translate.instant("PREBID_ON_PRODUCT.MAX_AMOUNT"));
    columnsArray.push(this.translate.instant("SHARED.PRICE"));
    columnsArray.push(this.translate.instant("PREBID_ON_PRODUCT.SPENT_AMOUNT"));
    columnsArray.push(this.translate.instant("SHARED.PREBID_SUBBUYER"));

    columnsArray.forEach((columnName,i)=>
    {
      const isColumn = this.dataGridColumns.find(c => c.dataField === columnName);
      if (!isColumn) {
        this.dataGridColumns.push({
          dataField: columnName,
          caption: columnName,
          visibleIndex: i,
          allowEditing: false,
          encodeHtml: false,
          editorOptions: {
            showClearButton: true
          }, 
          cellTemplate:null,
          width:null,
          type:null
        })
      }
    });

    this.items.forEach(row => {
      let item = {};
      columnsArray.forEach((column, i) => {
        item[column] = row.displayPrebidOnProductProperties[i].displayValue;
      });

      item['__item__'] = row;

      items.push(item);
    });
    this.dataGridItems=items;
  }

  generateFields = () => {
    const generatedItems = [];
    this.masterDataDropdowns = [];
    this.model.prebidOnProductProperties = this.model.prebidOnProductProperties.filter(e => e.propertyTypeId !== undefined);
    this.sortArray(this.model.prebidOnProductProperties, 'orderNumber', 1);

    return new Promise((resolve, reject) => {

      this.model.prebidOnProductProperties.forEach((field, i) => {
        if (field.propertyTypeId === 1 && this.model.prebidOnProductProperties[i]) {
          generatedItems.push(
            {
              dataField: 'prebidOnProductProperties[' + i + '].intValue',
              editorType: 'dxNumberBox',
              label: { text: field.name },
              editorOptions: {
                showSpinButtons: true,
                mode: 'number',
                format: '#0',
                min: 0,
                step: 1
              }
            }
          );
        } else if (field.propertyTypeId === 2 && this.model.prebidOnProductProperties[i]) {
          generatedItems.push(
            {
              dataField: 'prebidOnProductProperties[' + i + '].decimalValue',
              editorType: 'dxNumberBox',
              label: { text: field.name },
              editorOptions: {
                showSpinButtons: true,
                mode: 'number',
                format: '#0.0',
                min: 0,
                step: 0.1
              }
            }
          );
        } else if (field.propertyTypeId === 3 && !field.translatable && this.model.prebidOnProductProperties[i]) {
          generatedItems.push(
            {
              dataField: 'prebidOnProductProperties[' + i + '].stringValue',
              label: { text: field.name }
            }
          );
        } else if (field.propertyTypeId === 3 && field.translatable && this.model.prebidOnProductProperties[i]) {
          generatedItems.push(
            {
              dataField: 'prebidOnProductProperties[' + i + '].stringValue',
              label: { text: field.name },
              template: 'translatableField'
            }
          );
        } else if (field.propertyTypeId === 4 && field.propertyTypeFormatId === 11 && this.model.prebidOnProductProperties[i]) {
          generatedItems.push(
            {
              dataField: 'prebidOnProductProperties[' + i + '].dateTimeValue',
              label: { text: field.name },
              template: 'fullDateTemplate'
            }
          );
        } else if (field.propertyTypeId === 4 && field.propertyTypeFormatId === 12 && this.model.prebidOnProductProperties[i]) {
          generatedItems.push(
            {
              dataField: 'prebidOnProductProperties[' + i + '].dateTimeValue',
              label: { text: field.name },
              template: 'longDateTemplate'
            }
          );
        } else if (field.propertyTypeId === 4 && field.propertyTypeFormatId === 13 && this.model.prebidOnProductProperties[i]) {
          generatedItems.push(
            {
              dataField: 'prebidOnProductProperties[' + i + '].dateTimeValue',
              label: { text: field.name },
              template: 'longTimeTemplate'
            }
          );
        } else if (field.propertyTypeId === 4 && field.propertyTypeFormatId === 14 && this.model.prebidOnProductProperties[i]) {
          generatedItems.push(
            {
              dataField: 'prebidOnProductProperties[' + i + '].dateTimeValue',
              label: { text: field.name },
              template: 'shortDateTemplate'
            }
          );
        } else if (field.propertyTypeId === 4 && field.propertyTypeFormatId === 15 && this.model.prebidOnProductProperties[i]) {
          generatedItems.push(
            {
              dataField: 'prebidOnProductProperties[' + i + '].dateTimeValue',
              label: { text: field.name },
              template: 'shortTimeTemplate'
            }
          );
        } else if (field.propertyTypeId === 5 && this.model.prebidOnProductProperties[i]) {
          generatedItems.push(
            {
              dataField: 'prebidOnProductProperties[' + i + '].masterDataListRowId',
              label: { text: field.name },
              name: this.model.prebidOnProductProperties[i].masterDataListId,
              template: 'masterdataTemplate'
            }
          );
          this.model['prebidOnProductProperties[' + i + '].masterDataListRowId'] = this.model.prebidOnProductProperties[i].masterDataListRowId;
          this.masterDataDropdowns.push(this.model.prebidOnProductProperties[i]);
        } else if (field.propertyTypeId === 7 && this.model.prebidOnProductProperties[i]) {
          generatedItems.push(
            {
              dataField: 'prebidOnProductProperties[' + i + '].booleanValue',
              editorType: 'dxCheckBox',
              label: { text: field.name }
            }
          );
        }
      });

      const intervalResolve = setInterval(() => {
        if (generatedItems.length >= this.model.prebidOnProductProperties.length) {
          resolve(generatedItems);
          clearInterval(intervalResolve);
        }
      }, 50);

    });
  }

  onOpenedBoxes = (e: any, index: number) => {
    e.component.option('dataSource', this.comboBoxes[index]);
  }

  generateForm = async () => {
    let items = [];
    let generatedItems = null;
    this.prebidOnProductFormItems=items;
    const intervalPrebidOnProductProperties = setInterval(async () => {
      items = [];
      generatedItems = null;
      if (this.model.prebidOnProductProperties.length > 0) {
        clearInterval(intervalPrebidOnProductProperties);
        generatedItems = await this.generateFields();
        items.push(
          {
            itemType: 'group',
            caption: '',
            items: generatedItems
          });
        this.prebidOnProductFormItems=items;
        this.spinner.hide();
      }
    }, 50);
  }


  sortArray(array, property, direction) {
    direction = direction || 1;
    array.sort(function compare(a, b) {
      let comparison = 0;
      if (a[property] > b[property]) {
        comparison = 1 * direction;
      } else if (a[property] < b[property]) {
        comparison = -1 * direction;
      }
      return comparison;
    });
    return array; // Chainable
  }

  checkIsSecondRestrictionLotPropertyFilled() {
    this.secondRestrictionLotPropertyFilled = true;
    if (this.secondRestrictionMasterDataId) {
      let secondRestrictionLotProperty = this.model.prebidOnProductProperties.find(_ => _.masterDataListId === this.secondRestrictionMasterDataId);
      if (!secondRestrictionLotProperty || !secondRestrictionLotProperty.masterDataListRowId) {
        this.secondRestrictionLotPropertyFilled = false;
      } 
    }
  }

  checkIfRequiredLotPropertiesFilled() {
    this.requiredPrebidOnProductPropertiesFilled = true;
    if(this.model.price<=0 || this.model.amountWanted<=0)
      this.requiredPrebidOnProductPropertiesFilled = false;

    this.model.prebidOnProductProperties.filter(lp => lp.required).forEach((field, i) => {
      if (field.propertyTypeId === 1 && this.model.prebidOnProductProperties[i]) {
        if (field.intValue === undefined || field.intValue === null || field.intValue === 0) {
          this.requiredPrebidOnProductPropertiesFilled = false; 
        }
      } else if (field.propertyTypeId === 2 && this.model.prebidOnProductProperties[i]) {
        if (field.decimalValue === undefined || field.decimalValue === null || field.decimalValue === 0) {
          this.requiredPrebidOnProductPropertiesFilled = false; 
        }
      } else if (field.propertyTypeId === 3 && this.model.prebidOnProductProperties[i]) {
        if (field.stringValue === undefined || field.stringValue === null || field.stringValue === '') {
          this.requiredPrebidOnProductPropertiesFilled = false; 
        }
      } else if (field.propertyTypeId === 4 && this.model.prebidOnProductProperties[i]) {
        if (field.dateTimeValue === undefined || field.dateTimeValue === null) {
          this.requiredPrebidOnProductPropertiesFilled = false; 
        }
      } else if (field.propertyTypeId === 5 && this.model.prebidOnProductProperties[i]) {
        if (field.masterDataListRowId === undefined || field.masterDataListRowId === null) {
          this.requiredPrebidOnProductPropertiesFilled = false; 
        }
      } else if (field.propertyTypeId === 7 && this.model.prebidOnProductProperties[i]) {
        if (field.booleanValue === undefined || field.booleanValue === null) {
          this.requiredPrebidOnProductPropertiesFilled = false; 
        }
      }
    });
  }

  isRequired(data) {
    const matches = data.dataField.match(/\[(.*?)\]/);
    return this.model.prebidOnProductProperties[Number(matches[1])].required;
  }

  filterMasterDataListBySecondRestriction(masterDataList) {
    let unfilteredValues = masterDataList.values;
    if (this.secondRestrictionMasterDataId) {
      let secondRestrictedProductPropertyId = this.model.prebidOnProductProperties.find(_ => _.masterDataListId === this.secondRestrictionMasterDataId).productPropertyId;
      if (masterDataList.productPropertyId === secondRestrictedProductPropertyId) {
        return masterDataList.values.filter(item => !this.buyerSecondRestrictionMasterDataRowIds.includes(item.value))
      } 
    } 

    return unfilteredValues;
  }

  loadSelectedSubbuyer()
  {
    if(this.model.subbuyerId==null || this.model.subnumber==null) {
      this.selectedSubbuyer=null;
      return;
    }
    this.selectedSubbuyer=this.subbuyers.find(s => s.buyerId==this.model.subbuyerId && s.subNumber==this.model.subnumber);
  }

  add() { }

  @HostListener('window:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.key === "Escape") {
      close();
    }
  }
}
